import { ActionIcon, Portal } from '@mantine/core';
import * as icons from '@sloyd/icons';
import { useRef, useState } from 'react';
import Draggable from 'react-draggable';
import { ROOT_SECTION } from 'shared-base';
import { useCustomEvent } from '../../hooks/useCustomEvent';
import Details from '../Details/Details';
import { Top } from '../Logs/Logs.style';
import { preview } from './MaterialPreview.data';
import { Header, Image, Wrapper } from './MaterialPreview.style';

export type MaterialPreviewProps = {};

const ROOT = ROOT_SECTION('materials');

export function MaterialPreview(_props: MaterialPreviewProps) {
  const ref = useRef<HTMLDivElement>(null);
  const [item, setItem] = useState<Json | null>(null);

  useCustomEvent(
    'material/preview',
    (ev) => {
      if (!ev.open && !item) return;
      setItem(ev.item);
    },
    [item]
  );

  if (!item) return null;

  const { id, name } = item;

  const imageUrl = `${ROOT}/${id}.jpg`;

  return (
    <Portal>
      <Draggable nodeRef={ref}>
        <Wrapper
          ref={ref}
          className='MaterialPreview-wrapper'
          data-testid='MaterialPreview-wrapper'
        >
          <Top>
            <Header>
              {name} ({id?.replace('a', '')})
            </Header>
            <ActionIcon variant='subtle' onClick={() => setItem(null)}>
              <icons.IconX size={16} />
            </ActionIcon>
          </Top>
          <Image draggable={false} src={imageUrl} />
          {item && <Details config={preview.config} values={item} />}
        </Wrapper>
      </Draggable>
    </Portal>
  );
}

export default MaterialPreview;
